<style lang="scss" scoped>
.stepOne {
  background-color: #ebf6ff;
  border: 1px dashed #7bbcff;
  height: 434px;
  width: 674px;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .el-progress {
    width: 60%;
    margin: 0 auto;
  }
  .el-select {
    width: 50%;
    margin: 20px auto;
  }
  .outWrapper{
    align-self: center;
    display: grid;
    grid-template-columns: 1fr 40px;
    grid-column-gap: 20px;
    .status {
      background: white;
      border-radius: 10px;
      height: 90px;
      width: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 24px;
      i{
        font-size: 40px;
        font-weight: bold;
        margin-right: 4px;
      }
        span{
          display: inline-block;
        }
      &.success{
        background-color: rgb(139, 212, 162);
          color: green;


      }
      &.error{
        background-color: rgb(231, 162, 162);
          color: red;

      }
    }
  }
}
#checkVideo {
  margin: 30px;
  ::v-deep video {
    width: 50%;
    height: 50%;
  }
}
.goNextWrapper {
  .el-button {
    border: none;
    width: 100px;
    height: 40px;
    background-color: #ffc831;
    color: #b16614;
    border-radius: 20px;
  }
}
</style>
<template>
  <div class="stepOne">
    <div class="outWrapper">
      <div>
        <p>将检测您的麦克风是否正常工作</p>
        <p>请通过说话测试麦克风是否正常工作</p>
        <div v-if="devices&&devices.length&&!audioError" class="success status">
          <i class="el-icon-success"></i>
              <span>{{statusTip}}</span>
        </div>
        <div v-else class="error status">
          <i class="el-icon-error"></i>
           <span>{{statusTip}}</span>
        </div>
      </div>
    <volume-bar :volume="Math.ceil(soundLevel*10, 10)"></volume-bar>
    </div>

     <!-- <el-progress :percentage="parseInt(soundLevel*100, 10)"></el-progress> -->
    <el-select
      @change="handleAudioDeviceChange"
      v-model="currentDevice"
      placeholder="请选择麦克风"
    >
      <el-option
        v-for="(item, index) in devices"
        :key="index"
        :label="item.label"
        :value="item.deviceId"
      ></el-option>
    </el-select>

    <!-- <p>{{statusTip}}</p> -->
  </div>
</template>
<script>
// import recordMp4 from '../../../mixins/recordMp4';
import micDetect from '../../../mixins/micDetect';
import VolumeBar from '../../../components/VolumeBar.vue';
import Media from '../../../utils/Media';

export default {
  data() {
    return {
      devices: null,
      currentDevice: '',
      options: {
        video: false,
        audio: {
          deviceId: 'default',
        },
      },
      audioMedia: null,
    };
  },
  methods: {
    handleAudioDeviceChange(e) {
      this.audioError = false; // 重新start看看还有没有错误
      if (this.stream) {
        console.log('stop all the tracks');
        this.stream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      this.options.audio.deviceId = e;
      this.start();
    },
    updateDeviceList() {
      //TODO:这里的逻辑应该和video的一起抽离出来
      return this.audioMedia
        .getAudioDevices()
        .then((devices) => {
          console.log('receive devices', devices);
          this.devices = devices;
          // this.options.audio.deviceId = 'default'; // 把设备设置为默认的
          if (!devices || !Array.isArray(devices) || devices.length === 0) {
            this.currentDevice = '';
          } else {
            this.currentDevice = devices[0].deviceId; //TODO:how to know which deviceid the current track is using
          }
          return devices;
        })
        .catch((err) => {});
    },
    start() {
      if (!this.audioMedia) this.audioMedia = new Media(this.options);
      this.$emit('audioCheckStart');
      this.audioMedia.start().then((stream) => {
          if (stream) {
            this.initDetector(stream);
            this.updateDeviceList()
              .then((devices) => {
                const tracks = stream.getAudioTracks();
                devices.forEach((de) => {
                  if (de.label === tracks[0].label) {
                    this.currentDevice = de.deviceId;
                  }
                });
                this.$emit('audioReady');
              })
              .catch((err) => {});
            navigator.mediaDevices.ondevicechange = (e) => {
              console.log('device change');
              this.updateDeviceList();
            };
          }
        });
    },
    handleGoNext() {
      this.$router.push('/user/devicetest/2');
    },
  },
  mixins: [micDetect],
  components: {
    VolumeBar,
  },
  created() {},
  mounted() {
    this.start();
  },
  beforeDestroy() {
    this.audioMedia.destroy();
  },
  deactivated() {},
  activated() {},
   props: {
    deviceStatus: {
      type: Object,
    },
    checkPassed: {
      type: [Boolean],
    },
  },
  watch: {},
  computed: {
    statusTip() {
      if (this.devices && this.devices.length) {
        return '已检测到麦克风';
      }
      if (this.audioError) {
        return '请检查是否正确安装麦克风!以保证考试顺利进行';
      }
      return '未检测到麦克风，请检查是否正确安装麦克风!以保证考试顺利进行';
    },
  },
};
</script>
